
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/attribute/create",
      function () {
        return require("private-next-pages/attribute/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/attribute/create"])
      });
    }
  